import { useTranslations } from "next-intl";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export const BadgePromoted = ({
  isPromoted,
  className,
  label,
}: {
  isPromoted: boolean;
  className?: string;
  label?: string;
}) => {
  const t = useTranslations("diets");
  if (!isPromoted) {
    return null;
  }

  return (
    <Badge
      className={cn(
        "absolute top-2 z-20 rounded-4xl bg-white pt-[7px] pb-[5px] font-medium text-xs max-md:right-2 md:left-2",
        className
      )}
      variant="outline"
    >
      {label || t("badges.promoted")}
    </Badge>
  );
};
